import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

const openCloseAnimation = trigger('openCloseAnimation', [
    transition(':enter', [style({ opacity: 0 }), animate('300ms ease-out', style({ opacity: 1 }))]),
    transition(':leave', [style({ opacity: 1 }), animate('300ms ease-in', style({ opacity: 0 }))])
]);

@Component({
    selector: 'fcp-accordion-item',
    templateUrl: './fcp-accordion-item.component.html',
    styleUrls: ['./fcp-accordion.component.less'],
    animations: [openCloseAnimation],
    standalone: false
})
export class FcpAccordionItemComponent {
    @Input() title: string;
    @Input() isOpen = false;
    @Input() disabled = false;

    @Output() toggleOpen = new EventEmitter<boolean>();
}
